import { Link } from "@ui/Atoms/Link/Link";
import type * as React from "react";

export type MobileTab = {
	label: string;
	href: string;
	icon: React.ReactNode;
	active?: boolean;
};

type Props = {
	tabs: MobileTab[];
};

export function MobileTabBar({ tabs }: Props) {
	return (
		<nav className="flex h-[84px] border-t border-[var(--border-default)] bg-[var(--surface-default)] pb-[calc(14px+env(safe-area-inset-bottom))]">
			{tabs.map((tab) => (
				<Link
					key={tab.href}
					href={tab.href}
					aria-current={tab.active ? "page" : undefined}
					className="flex flex-1 flex-col items-center justify-center gap-[3px]"
					style={{
						color: tab.active ? "var(--accent-500)" : "var(--content-faint)",
					}}
				>
					{tab.icon}
					<span className="text-[11px] font-semibold">{tab.label}</span>
				</Link>
			))}
		</nav>
	);
}
